import { render, staticRenderFns } from "./PopoverRow.vue?vue&type=template&id=28ced894&scoped=true&"
import script from "./PopoverRow.vue?vue&type=script&lang=js&"
export * from "./PopoverRow.vue?vue&type=script&lang=js&"
import style0 from "./PopoverRow.vue?vue&type=style&index=0&id=28ced894&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ced894",
  null
  
)

export default component.exports